import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  useAppContext,
  SET_INFORMATION_ALERT,
  SET_ERROR_ALERT,
  SET_LOADING,
  REFRESH_DATA,
} from "../../../Providers/AppProvider";
import axios from "axios";
import { Config } from "../../../Config";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "react-tooltip";

export default function PridaniUpravaSkupinyCilu({ data, novyZaznam }) {
  const { dispatch } = useAppContext();
  const [open, setOpen] = useState(false);
  const [skupinyCiluData, setSkupinyCiluData] = useState({});

  useEffect(() => {
    if (open === true) {
      setSkupinyCiluData(data)
      if (novyZaznam === false) {
        setSkupinyCiluData(data)
      }
      if (novyZaznam === true) {
        setSkupinyCiluData({})
      }
    }
  }, [data, open, novyZaznam]);

  const cancelButtonRef = useRef(null);

  function UpravitSkupinuCilu() {
    dispatch({ type: SET_LOADING, payload: true })

    axios
      .post(
        `${Config.ServerURL}/api/Vozidla/UpravaSkupinyCilu`,
        skupinyCiluData,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message });
        }
        setOpen(false);
        dispatch({ type: REFRESH_DATA })
        dispatch({ type: SET_LOADING, payload: false })
      })
      .catch((err) => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message });
        dispatch({ type: SET_LOADING, payload: false })
      });
  }

  function PridatSkupinuCilu() {
    dispatch({ type: SET_LOADING, payload: true })

    axios
      .post(
        `${Config.ServerURL}/api/Vozidla/PridaniSkupinyCilu`,
        skupinyCiluData,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.message) {
          dispatch({ type: SET_INFORMATION_ALERT, payload: res.data.message });
        }
        dispatch({ type: REFRESH_DATA })
        setOpen(false);
        dispatch({ type: SET_LOADING, payload: false })
      })
      .catch((err) => {
        dispatch({ type: SET_ERROR_ALERT, payload: err.response.data.message });
        dispatch({ type: SET_LOADING, payload: false })
      });
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="dialog-transition" />
          </Transition.Child>

          <div className="fixed inset-0 z-20 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="dialog-edit-ramecek sm:max-w-5xl">
                  <div className="dialog-edit-obsah">
                  <Dialog.Title as="h3" className="dialog-edit-nadpis-velky">
                  {novyZaznam === true && ("Přidání skupiny cílů:")}
                  {novyZaznam === false && ("Oprava skupiny cílů:")}
                  </Dialog.Title>

                    <div className="grid grid-cols-6 gap-3">
                      <div className="col-span-6 sm:col-span-3">
                        <label className="dialog-edit-pole-popis">
                        Název skupiny
                        </label>
                        <input
                          value={skupinyCiluData.nazevSkupiny || ""}
                          onChange={(e) =>
                            setSkupinyCiluData({
                              ...skupinyCiluData,
                              nazevSkupiny: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                      </div>
                      <div className="col-span-6 sm:col-span-6">
                        <label className="dialog-edit-pole-popis">
                          Cíle skupiny (oddělovač "čárka")
                        </label>
                        <textarea rows="5"
                          value={skupinyCiluData.cileSkupiny || ""}
                          onChange={(e) =>
                            setSkupinyCiluData({
                              ...skupinyCiluData,
                              cileSkupiny: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></textarea>
                      </div>
                      {/* Pořadi skupiny - jen při opravě*/}
                      {novyZaznam === false &&
                      (<div className="col-span-6 sm:col-span-3 admin-dialog-edit-sekce">
                        <label className="dialog-edit-pole-popis">
                        Preference pořadí skupiny v zobrazení rezervací dle cíle:
                        </label>
                        <input
                          value={skupinyCiluData.poradiSkupiny || 1}
                          onChange={(e) =>
                            setSkupinyCiluData({
                              ...skupinyCiluData,
                              poradiSkupiny: e.target.value,
                            })
                          }
                          className="admin-dialog-edit-pole-input"
                        ></input>
                        <label className="dialog-edit-pole-popis">
                            Zadejte: Nulu pro posun na první místo. Pořadí + 1 pro posun na zvolené místo. 
                        </label>
                      </div>)}
                      
                    </div>
                  </div>

                  {/* Tlačítka */}
                  <div className="dialog-edit-zapati-pozadi">
                    {novyZaznam === false &&
                      (<button
                        type="button"
                        className="admin-dialog-edit-tlacitko-akce"
                        onClick={() => UpravitSkupinuCilu()}
                      >
                        Uložit
                      </button>)}
                    {novyZaznam === true &&
                      (
                        <button
                          type="button"
                          className="admin-dialog-edit-tlacitko-akce"
                          onClick={() => PridatSkupinuCilu()}
                        >
                          Přidat
                        </button>
                      )}
                    <button
                      type="button"
                      className="admin-dialog-edit-tlacitko-zavrit"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Zrušit
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {novyZaznam === false &&
        (<div 
          data-tooltip-id="oprava-skupcilu-tooltip" 
          data-tooltip-content="Oprava skupiny cílů"
          data-tooltip-delay-show={Config.ToolTipAutoRefreshTime1} data-tooltip-variant="info" 
          onClick={() => setOpen(true)}
          className="admin-dialog-edit-ikona-oprava"
        >
          <span className="sr-only">Otevřit menu úprav</span>
          <PencilSquareIcon className="ikonka-velikostS" aria-hidden="true" />
          <Tooltip id="oprava-skupcilu-tooltip" />
        </div>)}
      {novyZaznam === true && (
        <div
          onClick={() => setOpen(true)}
          className={`admin-dialog-tlacitko-akce`}
        >
          Přidat Skupinu cílů
        </div>
      )}
    </>
  );
}
